export interface PublicShowcaseOfferItem {
  id: string;
  short_code: string;
  title: string;
  image_url?: string | null;
  original_price?: number | null;
  promotional_price?: number | null;
  discount_percent?: number | null;
  coupon_code?: string | null;
  is_coupon_only: boolean;
  marketplace: string;
  categories: string[];
  tracked_url: string;
  sent_at?: string | null;
  is_age_warning: boolean;
  selected_copy?: string | null;
  original_url?: string | null;
}

export interface PublicShowcaseData {
  tenant_name: string;
  tenant_slug: string;
  public_title: string;
  slogan?: string | null;
  logo_url?: string | null;
  primary_color: string;
  secondary_color: string;
  meta_pixel_id?: string | null;
  ga4_measurement_id?: string | null;
  privacy_policy_url?: string | null;
  vip_group_invite_link?: string | null;
  total_count: number;
  available_categories: string[];
  offers: PublicShowcaseOfferItem[];
}

export interface FetchShowcaseParams {
  search?: string;
  category?: string;
  limit?: number;
  offset?: number;
}

const API_BASE = '/api/public/showcase';

export async function fetchPublicShowcase(
  tenantSlug: string,
  params?: FetchShowcaseParams
): Promise<PublicShowcaseData> {
  const cleanSlug = encodeURIComponent(tenantSlug.trim().toLowerCase());
  const query = new URLSearchParams();

  if (params?.search && params.search.trim()) {
    query.set('search', params.search.trim());
  }
  if (params?.category && params.category.trim() && params.category !== 'all') {
    query.set('category', params.category.trim());
  }
  if (params?.limit) {
    query.set('limit', String(params.limit));
  }
  if (params?.offset) {
    query.set('offset', String(params.offset));
  }

  const queryString = query.toString();
  const url = queryString
    ? `${API_BASE}/${cleanSlug}?${queryString}`
    : `${API_BASE}/${cleanSlug}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(
      errorData.detail || 'Vitrine de ofertas não encontrada ou inativa.'
    );
  }

  return res.json();
}
